export const REACT_SELECT_MENU_PORTAL_PROPS = {
    menuPortalTarget: typeof document !== "undefined" ? document.body : null,
    menuPosition: "fixed" as const,
    menuShouldScrollIntoView: false,
    styles: {
        // Above Radix dialog overlay (1200) and content (1205)
        menuPortal: (base: Record<string, unknown>) => ({ ...base, zIndex: 1300 }),
    },
};

export function isReactSelectPortalEventTarget(target: EventTarget | null) {
    if (!(target instanceof Element)) return false;
    return Boolean(
        target.closest(".react-select__menu") ||
            target.closest(".react-select__menu-portal") ||
            target.closest(".react-select__option") ||
            target.closest(".react-select__menu-list")
    );
}

/** Call from DialogContent outside-handlers so portaled menus stay clickable. */
export function preventDialogCloseForReactSelect(event: {
    target: EventTarget | null;
    detail?: { originalEvent?: Event };
    preventDefault: () => void;
}) {
    const target =
        event.target ??
        (event.detail?.originalEvent?.target as EventTarget | null | undefined) ??
        null;
    if (isReactSelectPortalEventTarget(target)) {
        event.preventDefault();
    }
}
